import React, { createContext } from "react";
import { useAuthToken } from "../hooks/useAuthToken";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const auth = useAuthToken();
    return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
